import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hoverEffect?: boolean;
}
export function Card({
  className = '',
  hoverEffect = false,
  children,
  ...props
}: CardProps) {
  return <div className={`
        bg-white border border-[#d0d7de] rounded-md p-4
        ${hoverEffect ? 'hover:border-[#0969da] transition-colors duration-200' : ''}
        ${className}
      `} {...props} data-id="element-232">
      {children}
    </div>;
}